import { Badge } from "@/components/ui/badge"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { cn } from "@/lib/utils"

import {
  RESPONSE_FILTER_LABELS,
  RESPONSE_FILTERS,
  type ResponseFilter,
} from "./useQuestionListFilters"

interface QuestionListFilterProps {
  activeFilter: ResponseFilter
  filterCounts: Record<ResponseFilter, number>
  onFilterChange: (filter: ResponseFilter) => void
}

export const QuestionListFilter: React.FC<QuestionListFilterProps> = ({
  activeFilter,
  filterCounts,
  onFilterChange,
}) => {
  const { translate } = useTranslation()

  return (
    <div className="flex flex-wrap items-center">
      <div className="flex flex-wrap items-center gap-2">
        {RESPONSE_FILTERS.map((filter) => {
          const isActive = activeFilter === filter
          const label = translate(RESPONSE_FILTER_LABELS[filter])

          return (
            <button
              key={filter}
              type="button"
              aria-label={`${label} (${filterCounts[filter]})`}
              aria-pressed={isActive}
              onClick={() => onFilterChange(filter)}
              className={cn(
                "inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-medium transition-colors",
                isActive
                  ? "border-yellow1 bg-yellow1/15 text-yellow1"
                  : "border-grey4 text-grey5 hover:border-grey3 hover:text-white",
              )}
            >
              <span>{label}</span>
              <Badge variant="secondary" className="rounded-full px-1.5 py-0">
                {filterCounts[filter]}
              </Badge>
            </button>
          )
        })}
      </div>
    </div>
  )
}
